export class AddressDTO {
  streetAddress: string;
  city: string;
  state: string;
  country: string;

  constructor() {
    this.streetAddress = '';
    this.city = '';
    this.state = '';
    this.country = '';
  }
}
